<script setup>
  import { ref } from 'vue'

  const props = defineProps({
    type: { type: String, default: 'button' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    classList: { type: [String, Array, Object], default: '' }
  })

  const buttonRef = ref(null)

  const emit = defineEmits(['click'])

  defineExpose({ buttonRef })

  const handleClick = (event) => {
    emit('click', event)
  }
</script>

<template>
  <button
    ref="buttonRef"
    v-bind="$attrs"
    :type="type"
    :disabled="disabled"
    :class="[
      classList,
      { disabled, 'btn--is-loading': loading }
    ]"
    @click="handleClick"
  >
    <slot />
  </button>
</template>
